import React from 'react';
import styles from './About.module.css';
import { Link } from 'react-router-dom';
import aboutUsHero from '../../assets/Aboutus-Hero.png'; 
import aboutMission from '../../assets/AboutUs-Mission.png';

const About: React.FC = () => {
  return (
    <div className={styles.aboutPage}>
      {/* Hero Section */}
      <section className={styles.hero} style={{
    background: `linear-gradient(rgba(0, 0, 0, 0.86), rgba(8, 37, 53, 0.46)), url(${aboutUsHero}) no-repeat center center`,
    backgroundSize: 'cover'
  }}>
        <div className={styles.heroContent}>
          <h1>Empowering Education Through <span>Partnerships</span></h1>
          <p>Bridging the gap between institutions and cutting-edge tech education</p>
          <Link to="/courses" className={styles.ctaButton}>
            Explore Our Courses
          </Link>
        </div>
      </section>

      {/* Mission Section */}
      <section className={styles.mission}>
        <div className={styles.missionContent}>
          <h2>Our <span>Mission</span></h2>
          <p>
            At CyberINN, we collaborate with schools and institutions to deliver 
            industry-relevant tech education. Our goal is to prepare students for 
            the digital future through hands-on learning in cybersecurity, AI, 
            game development, and full-stack programming.
          </p>
        </div>
        <div className={styles.missionImage}>
          <img 
            src={aboutMission} 
            alt="Our Mission"
          />
        </div>
      </section>

      {/* Partnership Model */}
      <section className={styles.partnerships}>
        <h2>Our <span>Partnership</span> Model</h2>
        <div className={styles.modelCards}>
          <div className={styles.modelCard}>
            <div className={styles.icon}>1</div>
            <h3>Curriculum <br /> Integration</h3>
            <p>We adapt our courses to complement your existing programs</p>
          </div>
          <div className={styles.modelCard}>
            <div className={styles.icon}>2</div>
            <h3>Professional <br /> Instructors</h3>
            <p>Industry professionals deliver all training</p>
          </div>
          <div className={styles.modelCard}>
            <div className={styles.icon}>3</div>
            <h3>Ongoing <br /> Support</h3>
            <p>Continuous updates and teacher training</p>
          </div>
        </div>
      </section>

     {/* Call to Action */}
<section className={styles.cta}>
  <h2>Ready to <span>Partner</span> With Us?</h2>
  <p>Contact us to bring CyberINN programs to your institution</p>
  <Link to="/contact" className={styles.contactButton}>
    Get in Touch
  </Link>
</section>
    </div>
  );
};

export default About;